import { createFileRoute } from "@tanstack/react-router";
import { FeaturedShopsShowcase } from "@/components/featured-shops-showcase";
import { useTranslation } from "@/i18n";
import { socialImageMeta, breadcrumbLd } from "@/lib/seo";

const TITLE = "Featured Shops | BidNova Auctions";
const DESCRIPTION = "Discover trusted trading card shops on BidNova Auctions — Pokémon, Sports Cards, Magic, Yu-Gi-Oh!, One Piece, accessories and grading services from vetted UK sellers.";
const URL = "https://bidnovaauctions.uk/shops";

export const Route = createFileRoute("/shops/")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      ...socialImageMeta(),
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [breadcrumbLd([{ name: "Home", path: "/" }, { name: "Shops", path: "/shops" }])],
  }),
  component: ShopsIndexPage,
});

function ShopsIndexPage() {
  const { t } = useTranslation("community");
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 pt-10">
      <header className="mb-4 text-center">
        <p className="text-[11px] uppercase tracking-[0.2em] text-gold">{t("shops.index.eyebrow", "Featured Shops")}</p>
        <h1 className="mt-2 font-display text-4xl text-white sm:text-5xl">{t("shops.index.title", "Trusted BidNova sellers")}</h1>
        <p className="mx-auto mt-3 max-w-2xl text-muted-foreground">
          {t("shops.index.subtitle", "Every shop below has been reviewed and approved by the BidNova team.")}
        </p>
      </header>
      <FeaturedShopsShowcase variant="page" title={t("shops.index.directoryTitle", "All Featured Shops")} eyebrow={t("shops.index.directoryEyebrow", "Directory")} />
    </div>
  );
}
